import Slider from "@mui/material/Slider";
import React from "react";
import {
    ButtonPlayPause,
    ButtonQuality,
    ButtonShareWithTitle,
    ButtonSpeaker,
    CustomReactPlayer, HistoryExtended,
    Image,
    NumberListener, OverlayHistory,
    OverlayPlay,
    OverlayQuality,
    OverlayShare, Skeleton,
    Timeline, updatePlayerRatio,
    WithoutLogoClassStyle
} from '../../helpers/rendererHelper'
import "./PlayerMedium.css";
import Player from "./Player";

export default class PlayerMedium extends Player {
    render() {
        const {
            author,
            backgroundColor,
            buttonColor,
            bufferDuration,
            bufferPreviewed,
            defaultVolume,
            display,
            displayListener,
            embedEnable,
            error,
            facebook,
            fragment,
            historyHold,
            historyDisplay,
            isHistoryTimeDisplay,
            isHistoryClickable,
            isDirectControl,
            isHlsBuffered,
            light,
            listenerHold,
            logo,
            main,
            muted,
            neverPlayed,
            numberListener,
            onChangeCommittedFlush,
            playbackRate,
            playing,
            playlist,
            previousPlayTime,
            secondaryColor,
            stream,
            streams,
            title,
            translations,
            unavailableUrl,
            url,
            volume,
            timeline,
            timelineLoaded,
            twitter,
            twitterHashtags,
            twitterAccount,
            preview,
        } = this.state;

        const showPlayer = !!stream;
        const color = {backgroundColor: backgroundColor, color: secondaryColor};

        document.body.style.backgroundColor = backgroundColor;

        if (historyDisplay === 'under') {
            updatePlayerRatio(2, 2);
        } else {
            updatePlayerRatio(1, 1);
        }

        return <>
            <Skeleton hidden={showPlayer}></Skeleton>

            { showPlayer &&
                <>
                    <div className='player-wrapper medium-player' style={color}>
                        <OverlayQuality addTitle={false} streams={streams} stream={stream} main={main}
                                        translations={translations} buttonColor={buttonColor} backgroundColor={backgroundColor}
                                        onClickClose={this.handleCloseOverlay}
                                        load={this.load}/>
                        <OverlayShare embedEnable={embedEnable} facebook={facebook} twitter={twitter}
                                      twitterHashtags={twitterHashtags} twitterAccount={twitterAccount}
                                      translations={translations} buttonColor={buttonColor} backgroundColor={backgroundColor}
                                      onClickClose={this.handleCloseOverlay}/>
                        <OverlayHistory visible={historyDisplay === 'overlay'} timeline={timeline} historyHold={historyHold}
                                        timeColor={secondaryColor} isDirectControl={isDirectControl} bufferSize={bufferDuration}
                                        currentTrack={title} isHlsBuffered={isHlsBuffered} playing={playing} timelineLoaded={timelineLoaded}
                                        backgroundColor={backgroundColor} buttonColor={buttonColor} currentTime={previousPlayTime}
                                        showTimecode={isHistoryTimeDisplay} allowTimeshift={isHistoryClickable}
                                        onClickClose={this.handleCloseOverlay} onClick={this.handleSeekTo} preview={preview} streamFormat={stream?.format}
                                        fragment={fragment} playlist={playlist} type="overlay"/>
                        <div id="player-option-image">
                            <div id="player-image">
                                <OverlayPlay onClickPlay={this.handlePlay} onClickPause={this.handlePause} buttonColor={buttonColor} playing={playing}
                                             backgroundColor={backgroundColor} neverPlayed={neverPlayed}/>
                                <Image display={display} onLoad={this.onLoadImage} color={secondaryColor} translations={translations}
                                       buttonColor={buttonColor} neverPlayed={neverPlayed}/>
                            </div>
                        </div>
                        <div id="player" className={WithoutLogoClassStyle(logo)}>
                            <div id="player-text">
                                <ButtonShareWithTitle
                                    title={title}
                                    visibleShare={embedEnable || facebook || twitter}
                                    visibleHistory={historyDisplay === 'overlay'}
                                    buttonColor={buttonColor}
                                    onClick={this.handleOpenOverlay}
                                />
                                <div id="author-container" className="text-fade"><p id="author">{author}</p></div>
                                <NumberListener numberListener={numberListener} displayListener={displayListener}
                                                error={error} preview={preview} color={secondaryColor} listenerHold={listenerHold}/>
                            </div>
                            <Timeline
                                fragment={fragment}
                                playlist={playlist}
                                bufferSize={bufferDuration}
                                previousPlayTime={previousPlayTime}
                                neverPlayed={neverPlayed}
                                isHlsBuffered={isHlsBuffered}
                                isDirectControl={isDirectControl}
                                bufferPreviewed={bufferPreviewed}
                                onChangeCommittedFlush={onChangeCommittedFlush}
                                onChange={this.handleSeekTo}
                                streamFormat={stream.format}
                                onAirLabel={translations.onair}
                                secondaryColor={secondaryColor}
                                buttonColor={buttonColor}
                                isLoading={this?.player?.player?.isLoading}
                                isMedium={true}
                                player={this.player}
                            />
                            <div id="player-buttons" className="buttons">
                                <ButtonPlayPause
                                    onClickPlay={this.handlePlay}
                                    onClickPause={this.handlePause}
                                    color={buttonColor}
                                    playing={playing}
                                />
                                <ButtonSpeaker
                                    onClick={this.handleToggleMuted}
                                    color={buttonColor}
                                    muted={muted}
                                />
                                <Slider type='range' min={0} max={1} step={0.0000001} value={volume}
                                        style={{color: buttonColor}}
                                        defaultValue={defaultVolume}
                                        id="volume"
                                        onChange={this.handleVolumeChange}/>
                                <ButtonQuality
                                    visible={streams.length > 1}
                                    color={buttonColor}
                                    onClick={this.handleOpenOverlay}
                                />
                                <a id="logo" target="_blank" href="https://infomaniak.com">
                                    <p id="powered-by">by</p>
                                    <p id="infomaniak">infomaniak</p>
                                </a>
                            </div>
                        </div>
                        <CustomReactPlayer
                            myRef={this.ref}
                            url={url}
                            playing={playing}
                            light={light}
                            playbackRate={playbackRate}
                            volume={volume}
                            muted={muted}
                            neverPlayed={neverPlayed}
                            playlist={playlist}
                            fragment={fragment}
                            unavailableUrl={unavailableUrl}
                            onReady={this.onPlayerReady}
                            onProgress={this.handleProgress}
                            onPlay={this.handleOnPlay}
                            setPlayerInError={this.setPlayerInError}
                            preview={preview}
                        />
                    </div>

                    {historyDisplay === 'under' &&
                        <HistoryExtended timeline={timeline} timeColor={secondaryColor} playing={playing}
                                         textColor={buttonColor} isDirectControl={isDirectControl}
                                         currentTrack={title} streamFormat={stream?.format}
                                         backgroundColor={backgroundColor} historyHold={historyHold}
                                         currentTime={previousPlayTime} isHlsBuffered={isHlsBuffered}
                                         fragment={fragment} playlist={playlist}
                                         onClick={this.handleSeekTo} type="extended" preview={preview}
                                         showTimecode={isHistoryTimeDisplay} timelineLoaded={timelineLoaded}
                                         bufferSize={bufferDuration} historyDisplay={historyDisplay}
                                         allowTimeshift={isHistoryClickable}/>
                    }
                </>
            }
        </>;
    }
}
